export default {
  name: 'users',
  translationKey: 'users-module',
  routePrefix: 'users',
  routeNamePrefix: 'admin.users',
  directRoutesAvailable: false,
}
